{
  "de": {
    "logged_out": {
      "success": {
        "login": "Erneut anmelden",
        "title": "Deine Sitzung ist beendet!"
      }
    }
  }
}
